import { render, staticRenderFns } from "./EventSet.vue?vue&type=template&id=640c7803"
import script from "./EventSet.js?vue&type=script&lang=js&external"
export * from "./EventSet.js?vue&type=script&lang=js&external"
import style0 from "./EventSet.vue?vue&type=style&index=0&id=640c7803&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports